var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 6,
    viewBox: "0 0 182 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317",
    transform: "translate(-441 -521)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(441 521)",
    fill: "#5f63f2",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-2",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(457 521)",
    fill: "#5f63f2",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-3",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(473 521)",
    fill: "#5f63f2",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-4",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(489 521)",
    fill: "#5f63f2",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-5",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(505 521)",
    fill: "#5f63f2",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-6",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(521 521)",
    fill: "#5f63f2",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-7",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(537 521)",
    fill: "#5f63f2",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-8",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(553 521)",
    fill: "#5f63f2",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-9",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(569 521)",
    fill: "#5f63f2",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-10",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(585 521)",
    fill: "#5f63f2",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-11",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(601 521)",
    fill: "#5f63f2",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95-12",
    "data-name": "Ellipse 95",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(617 521)",
    fill: "#5f63f2",
    opacity: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressActive);
export default __webpack_public_path__ + "static/media/progress-active.c4fddd1b6b0f652e2f34ad820a41bea7.svg";
export { ForwardRef as ReactComponent };